import React from 'react';
import { useTranslation } from 'react-i18next';

import { OtpFlow } from './OtpFlow';

import { useOtpSMSFlow } from '../../../hooks';

import styles from './css/ModalOtpVerification.module.css';

const ModalOtpVerification = () => {
  const { t } = useTranslation('common');
  const useOtpBySms = useOtpSMSFlow();
  const title = useOtpBySms
    ? t('otpFlow.welcomeTitleSms')
    : t('otpFlow.welcomeTitle');

  return (
    <div className={styles.ModalOtpContainer}>
      <span className={styles.ModalOtpTitle}>
        {title}
      </span>

      <OtpFlow />
    </div>
  );
};

export { ModalOtpVerification };
